import {
  Backdrop,
  CircularProgress
} from "@mui/material"
import { useSelector, useDispatch } from "react-redux"
import React, { useEffect } from "react"

const Loading = (props) => {
  const loaderCount = useSelector((state) => state.Loader)
  
  return (
    <React.Fragment>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 999 }}
        open={loaderCount > 0}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </React.Fragment>
  );
};
export default Loading;
